export const CURRENTS_APP_ID = "currents";
export const CURRENTS_GRAPHQL = {
    listOceanAgents: `query ListOceanAgents($orgId: ID, $limit: Int, $nextToken: String) {
    listOceanAgents(orgId: $orgId, limit: $limit, nextToken: $nextToken) {
      items {
        id orgId name role icon iconS3Key description enabled version modelId skillIds memoryIds guardrailIds visibility minAccessLevel updatedAt
      }
      nextToken
    }
  }`,
    getOceanAgent: `query GetOceanAgent($agentId: ID!, $orgId: ID) {
    getOceanAgent(agentId: $agentId, orgId: $orgId) {
      id orgId name role icon iconS3Key description systemPromptTemplate modelId
      inferenceConfigJson skills skillIds memoryIds guardrailIds toolsJson permissionsJson
      memoryConfigJson orchestratorConfigJson visibility minAccessLevel appIds enabled version createdAt updatedAt
    }
  }`,
    getOceanOrgSkill: `query GetOceanOrgSkill($skillId: ID!, $orgId: ID) {
    getOceanOrgSkill(skillId: $skillId, orgId: $orgId) {
      id orgId name description icon skillType toolRefs promptText
      inputSchemaJson publishedScriptVersion draftScriptBody modelBindingJson enabled updatedAt
    }
  }`,
    listOceanOrgSkills: `query ListOceanOrgSkills($orgId: ID, $limit: Int) {
    listOceanOrgSkills(orgId: $orgId, limit: $limit) {
      items {
        id orgId name description icon skillType toolRefs promptText
        inputSchemaJson publishedScriptVersion draftScriptBody modelBindingJson enabled updatedAt
      }
    }
  }`,
    deleteOceanOrgSkill: `mutation DeleteOceanOrgSkill($skillId: ID!, $orgId: ID) {
    deleteOceanOrgSkill(skillId: $skillId, orgId: $orgId) { id }
  }`,
    updateOceanOrgSkill: `mutation UpdateOceanOrgSkill($skillId: ID!, $orgId: ID, $input: UpdateOceanOrgSkillInput!) {
    updateOceanOrgSkill(skillId: $skillId, orgId: $orgId, input: $input) {
      id orgId name skillType publishedScriptVersion draftScriptBody updatedAt
    }
  }`,
    createOceanOrgSkill: `mutation CreateOceanOrgSkill($input: CreateOceanOrgSkillInput!) {
    createOceanOrgSkill(input: $input) {
      id orgId name description icon skillType toolRefs modelBindingJson publishedScriptVersion enabled updatedAt
    }
  }`,
    generateOceanSkillScript: `mutation GenerateOceanSkillScript($input: GenerateOceanSkillScriptInput!) {
    generateOceanSkillScript(input: $input) {
      id skillType draftScriptBody inputSchemaJson publishedScriptVersion updatedAt
    }
  }`,
    testOceanSkillScript: `mutation TestOceanSkillScript($input: TestOceanSkillScriptInput!) {
    testOceanSkillScript(input: $input) {
      exitCode stdout stderr outputJson durationMs log
    }
  }`,
    testOceanModelSkill: `mutation TestOceanModelSkill($input: TestOceanModelSkillInput!) {
    testOceanModelSkill(input: $input) {
      prompt modelId jobId status s3Key mime durationMs costCents errorMessage stepsJson
    }
  }`,
    publishOceanSkillScript: `mutation PublishOceanSkillScript($input: PublishOceanSkillScriptInput!) {
    publishOceanSkillScript(input: $input) {
      id skillType publishedScriptVersion draftScriptBody updatedAt
    }
  }`,
    listOceanOrgMemories: `query ListOceanOrgMemories($orgId: ID, $limit: Int) {
    listOceanOrgMemories(orgId: $orgId, limit: $limit) {
      items { id orgId name description scope enabled updatedAt }
    }
  }`,
    listOceanOrgGuardrails: `query ListOceanOrgGuardrails($orgId: ID, $limit: Int) {
    listOceanOrgGuardrails(orgId: $orgId, limit: $limit) {
      items { id orgId name description ruleText enabled updatedAt }
    }
  }`,
    listOceanBedrockModels: `query ListOceanBedrockModels($limit: Int, $nextToken: String) {
    listOceanBedrockModels(limit: $limit, nextToken: $nextToken) {
      items { modelId label providerName sortOrder enabled updatedAt }
      nextToken
    }
  }`,
    createOceanAgent: `mutation CreateOceanAgent($input: CreateOceanAgentInput!) {
    createOceanAgent(input: $input) {
      id orgId name role enabled version
    }
  }`,
    updateOceanAgent: `mutation UpdateOceanAgent($agentId: ID!, $orgId: ID, $input: UpdateOceanAgentInput!) {
    updateOceanAgent(agentId: $agentId, orgId: $orgId, input: $input) {
      id orgId name role enabled version updatedAt
    }
  }`,
    deleteOceanAgent: `mutation DeleteOceanAgent($agentId: ID!, $orgId: ID) {
    deleteOceanAgent(agentId: $agentId, orgId: $orgId) { id }
  }`,
    invokeOceanAgent: `mutation InvokeOceanAgent($input: InvokeOceanAgentInput!) {
    invokeOceanAgent(input: $input) {
      jobId status kind feature modelId progress costCents createdAt
    }
  }`,
    getAIJob: `query GetAIJob($jobId: ID!) {
    getAIJob(jobId: $jobId) {
      jobId status progress costCents errorMessage errorCode providerUsageJson outputAssetKey outputAssetMime
      prompt modelId paramsJson feature createdAt startedAt completedAt
    }
  }`,
    listOceanMissionSteps: `query ListOceanMissionSteps($jobId: ID!, $limit: Int) {
    listOceanMissionSteps(jobId: $jobId, limit: $limit) {
      items {
        seq kind summary detailJson parentSeq createdAt
        startedAt durationMs costMillicents providerUsdMicros chargedUsdMicros inputTokens outputTokens
      }
    }
  }`,
    listOceanMissions: `query ListOceanMissions($from: AWSDateTime, $to: AWSDateTime, $orgId: ID, $agentId: ID, $appId: String, $status: String, $limit: Int) {
    listOceanMissions(from: $from, to: $to, orgId: $orgId, agentId: $agentId, appId: $appId, status: $status, limit: $limit) {
      items {
        jobId appId userId triggerType triggeredBy agentId agentRole modelId feature status errorCode goalPreview
        userQuestion contextJson
        startedAt endedAt durationMs totalCostMillicents totalProviderUsdMicros totalChargedUsdMicros
        ledgerCents markup pricingUnmatched totalInputTokens totalOutputTokens
        stepCount toolCallCount errorCount toolBreakdownJson modelBreakdownJson
      }
      nextToken
    }
  }`,
    getOceanObsInsights: `query GetOceanObsInsights($from: AWSDateTime!, $to: AWSDateTime!, $orgId: ID, $appId: String, $groupBy: String!) {
    getOceanObsInsights(from: $from, to: $to, orgId: $orgId, appId: $appId, groupBy: $groupBy) {
      bucket missionCount failureCount totalCostMillicents totalProviderUsdMicros totalChargedUsdMicros
      totalInputTokens totalOutputTokens avgDurationMs
    }
  }`,
};
